module.exports = __webpack_public_path__ + "img/refresh.09547844.svg";